/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Forms_4Inputs */

const en_pc_tut_forms_4 = /** @type {(inputs: Pc_Tut_Forms_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save. Your entries are appended to the file.`)
};

const zh_pc_tut_forms_4 = /** @type {(inputs: Pc_Tut_Forms_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存，填写的内容会追加写入文件。`)
};

/**
* | output |
* | --- |
* | "Save. Your entries are appended to the file." |
*
* @param {Pc_Tut_Forms_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_forms_4 = /** @type {((inputs?: Pc_Tut_Forms_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Forms_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_forms_4(inputs)
	return zh_pc_tut_forms_4(inputs)
});
export { pc_tut_forms_4 as "pc.tut.forms.4" }